import { ROUTE_NAMES, USER_TYPES } from '../constants';

import Error404 from '../components/common/Error404.vue';

import Dashboard from '../components/Dashboard.vue';

import Assignments from '../components/Assignments.vue';

import Staff from '../components/Staff.vue';
import StaffMembers from '../components/staff/StaffMembers.vue';
import StaffGroups from '../components/staff/StaffGroups.vue';
import SuperUsers from '../components/SuperUsers.vue';

import Sensors from '../components/Sensors.vue';
import RoomProfiles from '../components/sensors/RoomProfiles.vue';
import ResidentProfiles from '../components/sensors/ResidentProfiles.vue';

import RoomConfiguration from '../components/RoomConfiguration.vue';
import RoomSettings from '../components/RoomSettings.vue';

import CheckIn from '../components/CheckIn.vue';
import NotCheckedIn from '../components/check-in/NotCheckedIn.vue';
import ResidentCheckIn from '../components/check-in/ResidentCheckIn.vue';

import NotCheckIn from '../components/NotCheckIn.vue';
import ReportConfiguration from '../components/not-check-in/ReportConfiguration.vue';
import NotCheckedInFull from '../components/not-check-in/NotCheckedInFull.vue';

import WirelessModules from '../components/WirelessModules.vue';

import WirelessSpeech from '../components/WirelessSpeech.vue';

import WanderManagement from '../components/WanderManagement';
import AccessGroups from '../components/wander-management/AccessGroups.vue';
import Schedulers from '../components/wander-management/Schedulers';

import Reports from '../components/Reports.vue';
import ReportForm from '../components/reports/ReportForm.vue';
import ShowReportForm from '../components/reports/ShowReportForm.vue';

import Settings from '../components/Settings.vue';
import Organization from '../components/settings/Organization.vue';
// import ColorScheme from '../components/settings/ColorScheme.vue';
import AssignmentsConf from '../components/settings/AssignmentsConf.vue';
import TargetTime from '../components/settings/TargetTime.vue';
import LogSettings from '../components/settings/LogSettings.vue';
import TabVisibility from '../components/settings/TabVisibility.vue';
import Other from '../components/settings/Other.vue';

import Frame from '../components/external/Frame.vue';

import Maintenance from '../components/Maintenance.vue';

import AuditTrail from '../components/AuditTrail.vue';
import AuditTrail_LogIn from '../components/audit-trail/LogIn.vue';
import AuditTrail_RoomConfiguration from '../components/audit-trail/RoomConfiguration.vue';

import DutySelector from '../components/DutySelector.vue';

export const routes = [
    {
        path: '/dashboard',
        name: ROUTE_NAMES.DASHBOARD,
        component: Dashboard,
        meta: {
            icon: 'pie-chart',
            help: type => 'dashboard.user-type-' + type,
            autoTabs: false,
            hasSearch: false,
            menu: true,
            visibility: /* istanbul ignore next */ () => true,
        },
    },
    {
        path: '/',
        redirect: {
            name: ROUTE_NAMES.DASHBOARD,
        },
    },
    {
        path: '/assignments',
        name: ROUTE_NAMES.ASSIGNMENTS,
        component: Assignments,
        meta: {
            icon: 'assignment',
            help: type => 'assignments.user-type-' + type,
            autoTabs: false,
            hasSearch: true,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, type) =>
                imt && type !== USER_TYPES.SYS_ADMIN && type !== USER_TYPES.USER
                    ? true
                    : visibleTabs.assignments && type !== USER_TYPES.SYS_ADMIN && type !== USER_TYPES.USER,
        },
    },
    {
        path: '/super-users',
        name: ROUTE_NAMES.SUPER_USERS,
        component: SuperUsers,
        meta: {
            icon: 'staff-group',
            help: 'super-users',
            autoTabs: false,
            hasSearch: false,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, type) =>
                imt && type === USER_TYPES.SYS_ADMIN ? true : type === USER_TYPES.SYS_ADMIN,
        },
    },
    {
        path: '/duty-selector',
        name: ROUTE_NAMES.DUTY_SELECTOR,
        component: DutySelector,
        meta: {
            help: 'duty-selector',
            autoTabs: false,
            hasSearch: false,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, type) =>
                type === USER_TYPES.SUPER_USER ||
                (type !== USER_TYPES.SYS_ADMIN && visibleTabs.duty_selector),
        },
    },
    {
        path: '/staff',
        name: ROUTE_NAMES.STAFF,
        component: Staff,
        redirect: '/staff/members',
        meta: {
            icon: 'staff-group',
            help: 'staff.members',
            autoTabs: true,
            hasSearch: true,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, type) =>
                imt
                    ? type === USER_TYPES.USER_ADMIN || type === USER_TYPES.SUPER_USER
                    : visibleTabs.assignments && type !== USER_TYPES.SYS_ADMIN && type !== USER_TYPES.USER,
        },
        children: [
            {
                path: 'members',
                name: ROUTE_NAMES.STAFF__MEMBERS,
                component: StaffMembers,
                meta: {
                    help: 'staff.members',
                },
            },
            {
                path: 'groups',
                name: ROUTE_NAMES.STAFF__GROUPS,
                component: StaffGroups,
                meta: {
                    help: 'staff.groups',
                },
            },
        ],
    },
    {
        path: '/sensors',
        name: ROUTE_NAMES.SENSORS,
        component: Sensors,
        redirect: '/sensors/room-profiles',
        meta: {
            icon: 'sensor',
            help: type => 'sensor.room-profiles.user-type-' + type,
            autoTabs: true,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, type) =>
                imt ? false : visibleTabs.resident_profiles && type !== USER_TYPES.SYS_ADMIN,
        },
        children: [
            {
                path: 'room-profiles',
                name: ROUTE_NAMES.SENSORS__ROOM_PROFILES,
                component: RoomProfiles,
                meta: {
                    help: type => 'sensor.room-profiles.user-type-' + type,
                    hasSearch: true,
                },
            },
            {
                path: 'resident-profiles',
                name: ROUTE_NAMES.SENSORS__RESIDENT_PROFILES,
                component: ResidentProfiles,
                meta: {
                    help: type => 'sensor.resident-profiles.user-type-' + type,
                    hasSearch: false,
                },
                children: [
                    {
                        path: 'add',
                        name: ROUTE_NAMES.SENSORS__RESIDENT_PROFILES__ADD,
                        component: ResidentProfiles,
                        meta: {
                            help: type => 'sensor.resident-profiles.user-type-' + type,
                        },
                    },
                    {
                        path: ':id',
                        name: ROUTE_NAMES.SENSORS__RESIDENT_PROFILES__EDIT,
                        component: ResidentProfiles,
                        meta: {
                            help: type => 'sensor.resident-profiles.user-type-' + type,
                        },
                    },
                ],
            },
        ],
    },
    {
        path: '/room-configuration',
        name: ROUTE_NAMES.ROOM_CONFIGURATION,
        component: RoomConfiguration,
        meta: {
            icon: 'room-config',
            help: type => 'room-configuration.user-type-' + type,
            autoTabs: false,
            hasSearch: true,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, type) =>
                imt ? false : visibleTabs.room_configuration && type !== USER_TYPES.SYS_ADMIN,
        },
    },
    {
        path: '/room-settings',
        name: ROUTE_NAMES.ROOM_SETTINGS,
        component: RoomSettings,
        meta: {
            icon: 'room-settings',
            help: 'room-settings',
            autoTabs: false,
            hasSearch: true,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, type) =>
                imt ? false : visibleTabs.room_configuration && type === USER_TYPES.SYS_ADMIN,
        },
    },
    {
        path: '/check-in',
        name: ROUTE_NAMES.CHECK_IN,
        component: CheckIn,
        redirect: '/check-in/not-checked-in',
        meta: {
            icon: 'checkin',
            help: 'checkin.not-checked-in',
            autoTabs: true,
            hasSearch: true,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, type) =>
                imt ? false : visibleTabs.checkin && type !== USER_TYPES.SYS_ADMIN,
        },
        children: [
            {
                path: 'not-checked-in',
                name: ROUTE_NAMES.CHECK_IN__NOT_CHECKED_IN,
                component: NotCheckedIn,
                meta: {
                    help: 'checkin.not-checked-in',
                },
            },
            {
                path: 'resident-check-in',
                name: ROUTE_NAMES.CHECK_IN__RESIDENT_CHECK_IN,
                component: ResidentCheckIn,
                meta: {
                    help: 'checkin.resident-check-in',
                },
            },
        ],
    },
    {
        path: '/wireless-modules',
        name: ROUTE_NAMES.WIRELESS_MODULES,
        component: WirelessModules,
        meta: {
            icon: 'signal',
            help: type => 'wireless-modules.user-type-' + type,
            autoTabs: false,
            hasSearch: false,
            menu: true,
            visibility:
                /**
                 * WirelessModules tab visibility function (as example of tab visibility function)
                 * @param {boolean} imt - true for Telligence system
                 * @param {object} visibleTabs - visibleTabs.tab_name===true if the tab tab_name
                 *                  enabled in NISM GUI
                 * @param {number} userType - user type
                 *
                 * @returns {boolean} true if the tab should be visible to current user
                 */
                (imt, visibleTabs, userType) =>
                    //  Disable the tab, if Telligence system.
                    //  Otherwise, allow the tab if it is visible accordingly NISM settings.
                    //  Otherwise, allow the tab for sys admin (even if it is disabled in NISM).
                    //  Otherwise, disable this tab visibility.
                    imt ? false : visibleTabs.wireless_modules || userType === USER_TYPES.SYS_ADMIN,
        },
        children: [
            {
                path: 'add',
                name: ROUTE_NAMES.WIRELESS_MODULES__ADD,
                component: WirelessModules,
                meta: {
                    help: type => 'wireless-modules.user-type-' + type,
                },
            },
            {
                path: ':id',
                name: ROUTE_NAMES.WIRELESS_MODULES__EDIT,
                component: WirelessModules,
                meta: {
                    help: type => 'wireless-modules.user-type-' + type,
                },
            },
        ],
    },
    {
        path: '/wireless-speech',
        name: ROUTE_NAMES.WIRELESS_SPEECH,
        component: WirelessSpeech,
        meta: {
            icon: 'wireless-speech',
            help: 'wireless-speech',
            autoTabs: false,
            hasSearch: false,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, userType) =>
                imt
                    ? false
                    : visibleTabs.wireless_speech &&
                      userType !== USER_TYPES.SYS_ADMIN &&
                      userType !== USER_TYPES.USER,
        },
    },
    {
        path: '/wander-management',
        name: ROUTE_NAMES.WANDER_MANAGEMENT,
        component: WanderManagement,
        redirect: '/wander-management/access-groups',
        meta: {
            icon: 'lock',
            autoTabs: true,
            hasSearch: true,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, userType) =>
                //  Disable the tab, if Telligence system.
                //  Otherwise, allow the tab if it is visible accordingly NISM settings.
                //  Otherwise, allow the tab for sys admin (even if it is disabled in NISM).
                //  Otherwise, disable this tab visibility.
                imt ? false : visibleTabs.access_control || userType === USER_TYPES.SYS_ADMIN,
        },
        children: [
            {
                path: 'access-groups',
                name: ROUTE_NAMES.WANDER_MANAGEMENT__ACCESS_GROUPS,
                component: AccessGroups,
                meta: {
                    help: 'wander-management.access-groups',
                },
                children: [
                    {
                        path: 'add',
                        name: ROUTE_NAMES.WANDER_MANAGEMENT__ACCESS_GROUPS__ADD,
                        component: AccessGroups,
                        meta: {
                            help: 'wander-management.access-groups',
                        },
                    },
                    {
                        path: ':id',
                        name: ROUTE_NAMES.WANDER_MANAGEMENT__ACCESS_GROUPS__EDIT,
                        component: AccessGroups,
                        meta: {
                            help: 'wander-management.access-groups',
                        },
                    },
                ],
            },
            {
                path: 'schedulers',
                name: ROUTE_NAMES.WANDER_MANAGEMENT__SCHEDULERS,
                component: Schedulers,
                meta: {
                    help: 'wander-management.schedulers',
                },
                children: [
                    {
                        path: 'add',
                        name: ROUTE_NAMES.WANDER_MANAGEMENT__SCHEDULERS__ADD,
                        component: Schedulers,
                        meta: {
                            help: 'wander-management.schedulers',
                        },
                    },
                    {
                        path: ':id',
                        name: ROUTE_NAMES.WANDER_MANAGEMENT__SCHEDULERS__EDIT,
                        component: Schedulers,
                        meta: {
                            help: 'wander-management.schedulers',
                        },
                    },
                ],
            },
        ],
    },
    {
        path: '/reports',
        name: ROUTE_NAMES.REPORTS,
        component: Reports,
        meta: {
            icon: 'graphic',
            help: 'reports',
            autoTabs: false,
            hasSearch: false,
            menu: true,
            visibility: /* istanbul ignore next */ () => true,
        },
        children: [
            {
                path: ':id([1-6])',
                name: ROUTE_NAMES.REPORTS__EDIT,
                component: ReportForm,
                props: route => ({
                    id: Number(route.params.id),
                    mode: 'add',
                    queryData: route.query,
                }),
                meta: {
                    help: (user, report) =>
                        'report-config.report-' + report + '.user-type-' + (user === 4 ? 3 : user), // for user show the same report help
                }, // as for the user admin
            },
            {
                path: 'custom/:id(\\d+)',
                name: ROUTE_NAMES.REPORTS__CUSTOM__EDIT,
                component: ReportForm,
                props: route => ({
                    id: Number(route.params.id),
                    mode: 'edit',
                    queryData: route.query,
                }),
                meta: {
                    help: (user, report) =>
                        'report-config.report-' + report + '.user-type-' + (user === 4 ? 3 : user), // for user show the same report help
                    autoTabs: false, // as for the user admin
                    hasSearch: false,
                    visibility: /* istanbul ignore next */ () => true,
                },
            },
            {
                path: ':custom?/show',
                name: ROUTE_NAMES.REPORTS__SHOW,
                component: ShowReportForm,
                props: route => ({
                    custom: String(route.params.custom),
                    reportData: route.query,
                }),
                meta: {
                    help: (user, report) => 'report-show.report-' + report,
                },
            },
        ],
    },
    {
        path: '/not-check-in',
        name: ROUTE_NAMES.NOT_CHECKED_IN,
        component: NotCheckIn,
        redirect: '/not-check-in/report-configuration',
        meta: {
            autoTabs: true,
            help: 'not-check-in',
            icon: 'not-check-in',
            menu: true,
            visibility: (imt, visibleTabs, type) =>
                !imt && type === USER_TYPES.SYS_ADMIN && visibleTabs.checkin,
        },
        children: [
            {
                path: 'report-configuration',
                name: ROUTE_NAMES.NOT_CHECKED_IN__REPORT_CONFIGURATION,
                component: ReportConfiguration,
                meta: {
                    help: 'not-check-in.report-configuration',
                    hasSearch: false,
                },
            },
            {
                path: 'not-checked-in',
                name: ROUTE_NAMES.NOT_CHECKED_IN__NOT_CHECKED_IN_FULL,
                component: NotCheckedInFull,
                meta: {
                    help: 'not-check-in.not-checked-in-full',
                    hasSearch: true,
                },
            },
        ],
    },
    {
        path: '/settings',
        name: ROUTE_NAMES.SETTINGS,
        component: Settings,
        redirect: '/settings/organization',
        meta: {
            icon: 'settings',
            help: 'settings',
            autoTabs: true,
            hasSearch: false,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, type) =>
                imt && type === USER_TYPES.SYS_ADMIN ? true : type === USER_TYPES.SYS_ADMIN,
        },
        children: [
            {
                path: 'organization',
                name: ROUTE_NAMES.SETTINGS__ORGANIZATION,
                component: Organization,
                meta: {
                    help: 'settings.organization',
                },
            },
            // {
            //     path: 'color-scheme',
            //     name: ROUTE_NAMES.SETTINGS__COLOR_SCHEME,
            //     component: ColorScheme,
            //     meta: {
            //         help: 'color-scheme'
            //     }
            // },
            {
                path: 'assignments-configuration',
                name: ROUTE_NAMES.SETTINGS__ASSIGNMENTS_CONF,
                component: AssignmentsConf,
                meta: {
                    help: 'settings.assignments-configuration',
                },
            },
            {
                path: 'target-time',
                name: ROUTE_NAMES.SETTINGS__TARGET_TIME,
                component: TargetTime,
                meta: {
                    help: 'settings.target-time',
                },
            },
            {
                path: 'log-settings',
                name: ROUTE_NAMES.SETTINGS__LOG_SETTINGS,
                component: LogSettings,
                meta: {
                    help: 'settings.log-settings',
                },
            },
            {
                path: 'tab-visibility',
                name: ROUTE_NAMES.SETTINGS__TAB_VISIBILITY,
                component: TabVisibility,
                meta: {
                    help: 'settings.tab-visibility',
                },
            },
            {
                path: 'other',
                name: ROUTE_NAMES.SETTINGS__OTHER,
                component: Other,
                meta: {
                    help: 'settings.other',
                },
            },
        ],
    },
    {
        path: '/maintenance',
        name: ROUTE_NAMES.MAINTENANCE,
        component: Maintenance,
        meta: {
            icon: 'maintance',
            help: 'maintenance',
            autoTabs: false,
            hasSearch: false,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, type) =>
                imt && type === USER_TYPES.SYS_ADMIN ? true : type === USER_TYPES.SYS_ADMIN,
        },
    },
    {
        path: '/audit-trail',
        name: ROUTE_NAMES.AUDIT_TRAIL,
        component: AuditTrail,
        redirect: '/audit-trail/log-in',
        meta: {
            icon: 'audit-trail',
            help: 'audit-trail',
            autoTabs: true,
            hasSearch: false,
            menu: true,
            visibility: /* istanbul ignore next */ (imt, visibleTabs, userType) =>
                userType === USER_TYPES.SYS_ADMIN,
        },
        children: [
            {
                path: 'log-in',
                name: ROUTE_NAMES.AUDIT_TRAIL__LOG_IN,
                component: AuditTrail_LogIn,
                meta: {
                    help: 'audit-trail.log-in',
                },
            },
            {
                path: 'room-configuration',
                name: ROUTE_NAMES.AUDIT_TRAIL__ROOM_CONFIGURATION,
                component: AuditTrail_RoomConfiguration,
                meta: {
                    help: 'audit-trail.room-configuration',
                },
            },
        ],
    },
    {
        path: '/external/:id(\\d+)',
        name: ROUTE_NAMES.EXTERNAL,
        component: Frame,
        meta: {
            icon: 'plugin',
            help: 'reports',
            autoTabs: false,
            hasSearch: false,
            visibility: () => true,
        },
    },
    {
        path: '/error-404',
        name: ROUTE_NAMES.ERROR_404,
        component: Error404,
        meta: {
            help: 'introduction',
            menu: false,
            hasSearch: false,
            autoTabs: false,
            visibility: () => true,
        },
    },
];
